import bezierSpline from '@turf/bezier-spline';
import { lineString } from '@turf/helpers';

export default {
  /**
   * Filter the geojson to only return the ones present state.places.ids
   * @param {object} state of the app
   * @returns {object} type and features
   */
  filterGeojson(state) {
    // Early return if state.geojson is not set
    // was causing errors on load on some occasions
    if (Object.keys(state.geojson).length === 0) {
      return { type: 'FeatureCollection', features: [] };
    }

    const { type, features } = state.geojson;

    // If a route is selected filter with all types and results
    if (state.formValues['tourist-route'] && state.formValues['tourist-route'] !== '-1') {
      const filteredFeatures = features.filter((feature) => {
        return state.results.includes(Number(feature.properties.nid), 0);
      });

      return { type, features: filteredFeatures };
    }

    // If no route is set return only the cellarFeatures
    let cellarFeatures = {};

    const defaultTypes = new Set(['pin-vigneron', 'pin-cooperative', 'pin-maison']);
    cellarFeatures = features.filter((feature) => {
      return defaultTypes.has(feature.properties.type);
    });

    if (state.results.length === 0) {
      return { type, features: cellarFeatures };
    }

    // Filter with store results
    const filteredCellarFeatures = cellarFeatures.filter((feature) => {
      return state.results.includes(Number.parseInt(feature.properties.nid, 10));
    });

    return { type, features: filteredCellarFeatures };
  },

  /**
   * getRoutes in GEOJSON format
   * @param {object} state
   * @param {Array} state.mainFilters
   * @returns {boolean | object}
   */
  getRoutes({ mainFilters }) {
    if (mainFilters.length > 0) {
      const route = mainFilters.find((filter) => filter.name === 'tourist-route');

      route.options.forEach((element) => {
        const curveRoute = bezierSpline(lineString(element.data.geometry.coordinates));
        element.data.geometry = curveRoute.geometry;
      });

      route.options.forEach((element) => {
        const curveRoute = bezierSpline(lineString(element.data.geometry.coordinates));
        element.data.geometry = curveRoute.geometry;
      });

      return route.options;
    }

    return false;
  },
};
